<template>
  <div class="containter f-col-w">
  <div class="footer-box">
    <div class="f10 copy-right">
      版权所有© {{ year }}
      <a href="https://beian.miit.gov.cn/" target="_blank">*************** </a>
      All Rights Reserved.</div>
  </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      year:new Date().getFullYear()
    }
  },
  created() {
  },
  methods: {},
}
</script>

<style scoped lang="scss">

.containter {
  .footer-box {
    width: 100%;
    margin: 0 auto;
    height: 100%;
    position: relative;
    @include flex(center, center);

    .copy-right {
      height: 20px;
      line-height: 20px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/layoutCollege/components/footer.vue